// AUTO-GENERATED by Style Dictionary — DO NOT EDIT BY HAND.
// Source: business/ishvaram/packages/design-tokens/tokens/*.json5
// Regenerate: cd business/ishvaram && pnpm --filter @ishvaram/design-tokens build

/**
 * Raw design tokens — colors, typography, spacing, radii.
 *
 * Consumed by `packages/ui/src/theme/palettes.ts` (which layers light/dark
 * mode + the runtime Proxy on top of these values).
 *
 * To change a value, edit business/ishvaram/packages/design-tokens/tokens/*.json5
 * and regenerate.
 */
export const tokens = {
  breakpoint: {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    xxl: 1536,
  },
  color: {
    shared: {
      accent: "#b9644a",
      accentAction: "#b05a42",
      accentActionHover: "#9f503b",
      accentLight: "#b9644a15",
      accentBorder: "#b9644a30",
      primary: "#232446",
      gold: "#ffde59",
      goldSoft: "#ffde5930",
      goldBorder: "#ffde5940",
      dark: "#0f0f1a",
      textOnDark: "#ffffff",
      textOnDarkMuted: "#ffffffd9",
      textOnDarkFaint: "#ffffffa6",
      textOnDarkGhost: "#ffffff73",
      textOnAccent: "#ffffff",
      textOnPrimary: "#ffffff",
      darkSurface: "#ffffff1f",
      darkSurfaceStrong: "#ffffff33",
      darkBorder: "#ffffff29",
      planetSun: "#d97706",
      planetMoon: "#2563eb",
      planetMars: "#dc2626",
      planetMercury: "#059669",
      planetJupiter: "#eab308",
      planetVenus: "#db2777",
      planetSaturn: "#1e293b",
      planetRahu: "#4b5563",
      planetKetu: "#7c3aed",
      success: "#16a34a",
      error: "#dc2626",
      warning: "#d97706",
      warningTint: "#fde68a",
      successTint: "#bbf7d0",
      successBg: "#f0fdf4",
      successText: "#15803d",
      errorTint: "#fecaca",
      errorBg: "#fef2f2",
      errorText: "#b91c1c",
      errorTextDark: "#991b1b",
      warningBg: "#fef3c7",
      warningText: "#92400e",
      warningTextDark: "#a16207",
      warningOrange: "#ea580c",
      warningOrangeDark: "#c2410c",
      warningGold: "#ca8a04",
      successTextDark: "#166534",
      borderValid: "#16a34a60",
      info: "#2563eb",
      neutral400: "#a8a29e",
      neutral500: "#78716c",
      neutral300: "#d1d5db",
      turmeric: "#d98f00",
      turmericFaint: "#d98f0015",
      kumkum: "#b3261e",
      sandal: "#e6d2a8",
      sandalSoft: "#ebe1cc",
      copper: "#b87333",
      brass: "#c9a86a",
      ghee: "#fff7e6",
      whatsapp: "#25D366",
      instagram: "#E1306C",
      overlayLight: "#00000020",
      overlayMid: "#00000066",
      overlayDark: "#000000aa",
    },
    light: {
      bg: "#fdfaf4",
      bgWarm: "#fdf6e9",
      card: "#ffffff",
      surfaceRaised: "#ffffff",
      surfaceWarm: "#fff7e6",
      surfacePressed: "#f5efe1",
      border: "#ebe1cc",
      borderLight: "#f3ead4",
      borderWarm: "#ebe1cc",
      textMain: "#2a1a0e",
      textSub: "#6b4e3a",
      textFaint: "#806c5a",
      accentText: "#9f503b",
      statusSuccessText: "#166534",
      statusWarningText: "#92400e",
      statusErrorText: "#991b1b",
      statusInfoText: "#1d4ed8",
    },
    dark: {
      bg: "#0f0f1a",
      bgWarm: "#14142a",
      card: "#1a1a2e",
      surfaceRaised: "#1f1f38",
      surfaceWarm: "#25213d",
      surfacePressed: "#262640",
      border: "#ffffff1f",
      borderLight: "#ffffff14",
      borderWarm: "#ffffff1f",
      textMain: "#ffffff",
      textSub: "#ffffffd9",
      textFaint: "#ffffffa6",
      accentText: "#d08a74",
      statusSuccessText: "#4ade80",
      statusWarningText: "#f59e0b",
      statusErrorText: "#f87171",
      statusInfoText: "#60a5fa",
    },
  },
  iconSize: {
    xs: 8,
    sm: 12,
    md: 16,
    lg: 20,
    xl: 24,
    xxl: 26,
    xxxl: 32,
    giant: 40,
    display: 48,
    displayLg: 52,
    hero: 56,
  },
  layout: {
    container: {
      form: 480,
      report: 768,
      tool: 960,
      shell: 1200,
    },
    measure: {
      prose: "65ch",
      compact: "48ch",
    },
  },
  motion: {
    duration: {
      instant: 0,
      fast: 150,
      base: 250,
      slow: 400,
      glacial: 600,
    },
    easing: {
      linear: "linear",
      ease: "ease-out",
      emphasized: "cubic-bezier(0.2, 0, 0, 1)",
      ritual: "cubic-bezier(0.4, 0, 0.2, 1)",
    },
  },
  radius: {
    none: 0,
    sm: 8,
    md: 12,
    lg: 16,
    xl: 24,
    full: 999,
  },
  shadows: {
    elevation: {
      none: {
        ios: {
          shadowColor: "#3d2312",
          shadowOffset: {
            width: 0,
            height: 0,
          },
          shadowOpacity: 0,
          shadowRadius: 0,
        },
        android: {
          elevation: 0,
        },
        web: "none",
      },
      low: {
        ios: {
          shadowColor: "#3d2312",
          shadowOffset: {
            width: 0,
            height: 2,
          },
          shadowOpacity: 0.08,
          shadowRadius: 8,
        },
        android: {
          elevation: 3,
        },
        web: "0 2px 8px rgba(61, 35, 18, 0.08)",
      },
      medium: {
        ios: {
          shadowColor: "#3d2312",
          shadowOffset: {
            width: 0,
            height: 4,
          },
          shadowOpacity: 0.12,
          shadowRadius: 12,
        },
        android: {
          elevation: 6,
        },
        web: "0 4px 12px rgba(61, 35, 18, 0.12)",
      },
      high: {
        ios: {
          shadowColor: "#3d2312",
          shadowOffset: {
            width: 0,
            height: 6,
          },
          shadowOpacity: 0.14,
          shadowRadius: 16,
        },
        android: {
          elevation: 8,
        },
        web: "0 6px 16px rgba(61, 35, 18, 0.14)",
      },
      dramatic: {
        ios: {
          shadowColor: "#3d2312",
          shadowOffset: {
            width: 0,
            height: 4,
          },
          shadowOpacity: 0.18,
          shadowRadius: 20,
        },
        android: {
          elevation: 10,
        },
        web: "0 4px 20px rgba(61, 35, 18, 0.18)",
      },
    },
  },
  spacing: {
    xs: 4,
    sm: 8,
    smMd: 12,
    md: 16,
    lg: 24,
    xl: 32,
    xxl: 48,
    xxxl: 64,
  },
  font: {
    family: {
      sans: "DM Sans",
      sansHi: "Noto Sans Devanagari",
      serif: "PT Serif",
      mono: "JetBrainsMono",
    },
    size: {
      xs: 11,
      sm: 13,
      base: 15,
      md: 16,
      lg: 18,
      xl: 22,
      xxl: 28,
      xxxl: 36,
      display: 48,
    },
    weight: {
      regular: "400",
      medium: "500",
      semibold: "600",
      bold: "700",
      heavy: "800",
    },
    lineHeight: {
      tight: 1.2,
      normal: 1.4,
      relaxed: 1.6,
    },
  },
  typography: {
    variants: {
      display: {
        fontFamily: "SERIF",
        fontSize: 34,
        lineHeight: 40,
        fontWeight: "800",
        letterSpacing: -0.5,
      },
      headline: {
        fontFamily: "SERIF",
        fontSize: 28,
        lineHeight: 34,
        fontWeight: "800",
      },
      title: {
        fontFamily: "SERIF",
        fontSize: 22,
        lineHeight: 28,
        fontWeight: "700",
      },
      subtitle: {
        fontFamily: "SANS",
        fontSize: 18,
        lineHeight: 24,
        fontWeight: "700",
      },
      subtitleSmall: {
        fontFamily: "SANS",
        fontSize: 16,
        lineHeight: 22,
        fontWeight: "600",
      },
      body: {
        fontFamily: "SANS",
        fontSize: 15,
        lineHeight: 22,
        fontWeight: "400",
      },
      bodySmall: {
        fontFamily: "SANS",
        fontSize: 13,
        lineHeight: 18,
        fontWeight: "400",
      },
      caption: {
        fontFamily: "SANS",
        fontSize: 12,
        lineHeight: 16,
        fontWeight: "400",
      },
      button: {
        fontFamily: "SANS",
        fontSize: 15,
        lineHeight: 20,
        fontWeight: "700",
      },
      eyebrow: {
        fontFamily: "SANS",
        fontSize: 11,
        lineHeight: 15,
        fontWeight: "700",
        letterSpacing: 1.5,
        textTransform: "uppercase",
      },
      headlineHi: {
        fontFamily: "DEVANAGARI_BOLD",
        fontSize: 26,
        lineHeight: 38,
        fontWeight: "700",
      },
      titleHi: {
        fontFamily: "DEVANAGARI_BOLD",
        fontSize: 20,
        lineHeight: 30,
        fontWeight: "700",
      },
      bodyHi: {
        fontFamily: "DEVANAGARI",
        fontSize: 15,
        lineHeight: 24,
        fontWeight: "400",
      },
      captionHi: {
        fontFamily: "DEVANAGARI",
        fontSize: 12,
        lineHeight: 18,
        fontWeight: "400",
      },
    },
  },
  zIndex: {
    base: 0,
    sticky: 100,
    dropdown: 200,
    overlay: 300,
    modal: 400,
    popover: 500,
    toast: 600,
    tooltip: 700,
  },
} as const;

export type Tokens = typeof tokens;
